import { useUpdateArtist } from '@api';
import { useNotification } from '@common';
import { AxiosError } from 'axios';
import { UpdateArtistType } from 'server/generated/touring/types';

const TRANS_KEY = 'NOTIFICATIONS.UPDATE_ARTIST';

type UseUpdateArtistContactsReturnType = {
  submitUpdateArtistContacts: (data: UpdateArtistType) => Promise<boolean>;
};

export const useUpdateArtistContacts = (
  artistId: string
): UseUpdateArtistContactsReturnType => {
  const { mutateAsync: updateArtist } = useUpdateArtist();
  const { showSuccess, showError } = useNotification();

  const onSuccess = (): void => {
    showSuccess({
      title: `${TRANS_KEY}.SUCCESS.TITLE`,
      message: `${TRANS_KEY}.SUCCESS.MESSAGE`,
    });
  };

  const onError = (error: AxiosError): void => {
    showError({
      title: `${TRANS_KEY}.ERROR.TITLE`,
      message: `${TRANS_KEY}.ERROR.MESSAGE`,
      error,
    });
  };

  const submitUpdateArtistContacts = async (
    data: UpdateArtistType
  ): Promise<boolean> => {
    try {
      await updateArtist(
        {
          artistId,
          data,
        },
        { onSuccess, onError }
      );
      return true;
    } catch {
      return false;
    }
  };

  return { submitUpdateArtistContacts };
};
